import React from 'react';
import PropTypes from 'prop-types';
import BackgroundImage from './BackgroundImage';
import './Section.scss';

function Section(props) {
  const {
    bg = null,
    textColor = null,
    bgImage = null,
    bgImageOpacity = null,
    bgImageRepeat = null,
    className = null,
    children = null,
    size = null,
    ...otherProps
  } = props;

  return (
    <section
      className={`SectionComponent py-1 position-relative${bg ? ` bg-${bg}` : ''}${
        textColor ? ` text-${textColor}` : ''
      }${className ? ` ${className}` : ''}`}
      {...otherProps}
    >
      {bgImage && (
        <BackgroundImage image={bgImage} opacity={bgImageOpacity} repeat={bgImageRepeat} />
      )}
      <div
        className={`${['md', 'lg'].includes(size) ? ' container py-md-1' : ''}${
          size === 'lg' ? ' container my-md-1' : ''
        }`}
      >
        {children}
      </div>
    </section>
  );
}

Section.propTypes = {
  bg: PropTypes.string,
  textColor: PropTypes.string,
  size: PropTypes.string,
  bgImage: PropTypes.string,
  bgImageOpacity: PropTypes.number,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  bgImageRepeat: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node
};

export default Section;
